import { ContainerModule } from 'inversify';
import ClientCookie, { ICookies } from '@framework/router/Next/cookie/ClientCookie';

export const clientCookiesModule = (cookies: ICookies = {}): ContainerModule => {
  return new ContainerModule(({ bind }) => {
    bind(ClientCookie).toConstantValue(new ClientCookie(cookies));
  });
};

export const serverCookiesModule = new ContainerModule(({ bind }) => {
  bind(ClientCookie).toDynamicValue(async () => ClientCookie.fromNextHeader());
});
